import { WHISKER_CHART_LOG_FLOOR } from "./constants";
export function logPosition(value, min, max) {
    const safeVal = Math.max(value, WHISKER_CHART_LOG_FLOOR);
    const safeMin = Math.max(min, WHISKER_CHART_LOG_FLOOR);
    const safeMax = Math.max(max, WHISKER_CHART_LOG_FLOOR);
    const logMin = Math.log10(safeMin);
    const logMax = Math.log10(safeMax);
    if (logMax === logMin)
        return 50;
    return Math.min(100, Math.max(0, ((Math.log10(safeVal) - logMin) / (logMax - logMin)) * 100));
}
// Negative outlineOffset keeps the focus ring visible on segments clipped by the bar's overflow:hidden.
export const focusRingSx = (theme) => ({
    "&:focus-visible": {
        outline: `2px solid ${theme.palette.secondary.main}`,
        outlineOffset: -2,
    },
});
